import React from 'react'
import { space } from '@entur/tokens'
import { BannerAlertBox } from '@entur/alert'

type ModalErrorAlertProps = {
  title: string
}
export const ModalErrorAlert: React.FC<ModalErrorAlertProps> = (props) => {
  return (
    <BannerAlertBox variant="error" title={props.title} closable={false} style={{ marginBottom: space.large }}>
      Prøv på nytt eller ta kontakt med Entur support om det vedvarer.
    </BannerAlertBox>
  )
}
